import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=0bb7689e"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=js"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=js"
import style0 from "./GlobalSnackbar.vue?vue&type=style&index=0&id=0bb7689e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports